import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupText,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { FetchData } from './utils/DataFetch';
import { GetCookie, Timeout } from './utils/Common';

export class UserForm extends Component {
  static displayName = UserForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    // Cognito keys the account by the saved email, so unsaved edits to the field must not retarget the resend.
    this.savedUsernameEmail = props.model.UsernameEmail;
    this.state = {
      modalClientSearchForm: false,
      confirmPassword: '',
      resendingTempPassword: false,

      model: props.model,
      alert: props.alert,
      passwordVisible: false,
      confirmPasswordVisible: false,
      deltaPosition: { x: 0, y: 0 },
    };

    this.onSave = this.onSave.bind(this);
    this.onResendTemporaryPassword = this.onResendTemporaryPassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keydownHandler = this.keydownHandler.bind(this);
    //
    this.handleSaveEventSuccess = this.handleSaveEventSuccess.bind(this);
    //
    this.handleConfirmPass = this.handleConfirmPass.bind(this);
  }

  async onSave() {
    let model = this.state.model;

    if (model.EventType === 'insert') {
      model.CreateByUserId = this.user.userid;
    } else if (model.EventType === 'update') {
      model.UpdateByUserId = this.user.userid;
    }
    // Check if email has already been registered
    let userAlreadyRegistered = false;
    if (model.EventType === 'insert') {
      await FetchData('/checkemail', 'POST', this.user.token, model).then(
        (data) => {
          if (data === 'Email is already registered') {
            this.handleSaveEventSuccess({
              message: data,
              modal: true,
              color: 'warning',
            });
            userAlreadyRegistered = true;
          }
        }
      );
    }

    if (!userAlreadyRegistered) {
      await FetchData('/saveuser', 'POST', this.user.token, model).then(
        (data) => {
          if (data === 'Success') {
            this.props.handleSaveEventSuccess({
              message: data,
              modal: data === 'Success' ? false : true,
              color: data === 'Success' ? 'success' : 'warning',
            });
          } else {
            this.handleSaveEventSuccess({
              message: data,
              modal: true,
              color: 'warning',
            });
          }
        }
      );
    }
  }

  // Resets the account to a temporary password: Cognito reissues the invitation for users who never
  // signed in, and overwrites the password for everyone else. Either way the current password dies.
  async onResendTemporaryPassword() {
    const username = this.savedUsernameEmail;

    if (!username) {
      this.handleSaveEventSuccess({
        message: 'Save the user before sending a temporary password.',
        color: 'warning',
      });
      return;
    }

    const confirmed = window.confirm(
      `Reset the password for ${username}? Any password they are currently using will stop working immediately, and a temporary one will be emailed to them.`
    );
    if (!confirmed) return;

    this.setState({ resendingTempPassword: true });

    try {
      const response = await FetchData(
        '/resendtemporarypassword',
        'POST',
        this.user.token,
        { Username: username },
        { includeMeta: true }
      );

      this.handleSaveEventSuccess({
        message:
          response?.data?.message || 'Unable to send a new temporary password.',
        color: response?.ok ? 'success' : 'warning',
      });
    } catch (error) {
      this.handleSaveEventSuccess({
        message: 'Unable to send a new temporary password.',
        color: 'warning',
      });
    } finally {
      this.setState({ resendingTempPassword: false });
    }
  }

  handleSaveEventSuccess(alert) {
    this.setState(
      {
        alert: {
          color: alert.color,
          message: alert.message,
          isOpen: true,
        },
      },
      () => {
        window.setTimeout(() => {
          this.setState({ alert: { isOpen: false } });
        }, Timeout(alert.message));
      }
    );
  }

  handleChange(e) {
    let model = { ...this.state.model };

    if (e.target.type === 'checkbox') model[e.target.name] = e.target.checked;
    else if (e.target.type === 'number') {
      if (e.target.value !== '')
        model[e.target.name] = parseFloat(e.target.value);
      else model[e.target.name] = null;
    } else {
      model[e.target.name] = e.target.value;
      if (e.target.name === 'Email') model['UserName'] = e.target.value;
    }

    this.setState({ model });
  }

  handleConfirmPass(e) {
    this.setState({ confirmPassword: e.target.value });
  }

  keydownHandler(e) {
    if (e.keyCode === 83 && e.altKey) {
      this.onSave();
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.keydownHandler);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keydownHandler);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;
    const canResendTemporaryPassword =
      this.user.userrolename === 'Super Administrator' ||
      this.user.userrolename === 'Administrator';

    return (
      <Draggable handle=".handle" onDrag={this.handleDrag} {...dragHandlers}>
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '384px',
            }}
            backdrop="static"
          >
            <ModalHeader className="handle">New/Edit User</ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <Alert
                      color={this.state.alert.color}
                      isOpen={this.state.alert.isOpen}
                    >
                      <center>{this.state.alert.message}</center>
                    </Alert>
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12">
                    <h4>User Information</h4>
                  </Col>
                </Row>
                <Row name="Row1">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Firstname:
                      </InputGroupText>
                      <input
                        type="text"
                        name="FirstName"
                        className="form-control form-control-text"
                        value={this.state.model.FirstName}
                        maxLength={35}
                        onChange={this.handleChange}
                        tabIndex={1}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row name="Row2">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Lastname:
                      </InputGroupText>
                      <input
                        type="text"
                        name="LastName"
                        className="form-control form-control-text"
                        value={this.state.model.LastName}
                        maxLength={35}
                        onChange={this.handleChange}
                        tabIndex={2}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row name="Row3">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Username/Email:
                      </InputGroupText>
                      <input
                        type="text"
                        name="UsernameEmail"
                        className="form-control form-control-text"
                        value={this.state.model.UsernameEmail}
                        onChange={this.handleChange}
                        tabIndex={3}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row name="Row4">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Phone:
                      </InputGroupText>
                      <input
                        type="text"
                        name="Phone"
                        className="form-control form-control-text"
                        value={this.state.model.Phone}
                        onChange={this.handleChange}
                        tabIndex={4}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row nmae="Row5">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Phone2:
                      </InputGroupText>
                      <input
                        type="text"
                        name="PhoneAlt"
                        className="form-control form-control-text"
                        value={this.state.model.PhoneAlt}
                        onChange={this.handleChange}
                        tabIndex={5}
                        autoComplete="off"
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row name="Row6">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Role:
                      </InputGroupText>
                      <select
                        name="UserRoleName"
                        className="form-control form-control-text"
                        value={this.state.model.UserRoleName}
                        onChange={this.handleChange}
                        tabIndex={6}
                      >
                        <option value="">--Select Role--</option>
                        <option value="Interpreter">Interpreter</option>
                        <option value="Scheduler">Scheduler</option>
                        <option value="Administrator">Administrator</option>
                        <option value="Super Administrator">
                          Super Administrator
                        </option>
                        <option value="Rep">Rep</option>
                      </select>
                    </InputGroup>
                  </Col>
                </Row>
                <Row name="Row7">
                  <Col className="col-12">
                    <InputGroup size="sm">
                      <InputGroupText style={{ width: '100px' }}>
                        Disabled:
                      </InputGroupText>
                      <input
                        name="DisabledFlg"
                        type="checkbox"
                        className="input-checkbox"
                        checked={!!this.state.model.DisabledFlg}
                        onChange={this.handleChange}
                        tabIndex={7}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </div>
            </ModalBody>
            <ModalFooter>
              {this.state.model.EventType === 'update' &&
                canResendTemporaryPassword && (
                  <Button
                    color="secondary"
                    size="sm"
                    disabled={this.state.resendingTempPassword}
                    onClick={this.onResendTemporaryPassword}
                    tabIndex={8}
                  >
                    {this.state.resendingTempPassword
                      ? 'Sending...'
                      : 'Reset Password'}
                  </Button>
                )}
            </ModalFooter>
          </Modal>
        </div>
      </Draggable>
    );
  }
}
